import { render, staticRenderFns } from "./MoodHistory.vue?vue&type=template&id=4c8fdf54&scoped=true"
import script from "./MoodHistory.vue?vue&type=script&lang=js"
export * from "./MoodHistory.vue?vue&type=script&lang=js"
import style0 from "./MoodHistory.vue?vue&type=style&index=0&id=4c8fdf54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fdf54",
  null
  
)

export default component.exports